import { createSelector } from 'reselect';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';

import shuffle from 'lodash/shuffle';

export const selectFeaturedDeals = state => state.featuredDeals;
export const selectFeaturedDealsConfig = createSelector(
  selectFeaturedDeals,
  featuredDeals => featuredDeals.config,
);

// content selectors
export const selectFeaturedDealsContent = createSelector(
  selectFeaturedDeals,
  ({ featuredDealsContent }) => featuredDealsContent,
);

export const selectFeaturedDealsContentIsLoading = createSelector(
  selectFeaturedDealsContent,
  featuredDeals => featuredDeals.isLoading,
);

export const selectFeaturedDealsContentIsLoaded = createSelector(
  selectFeaturedDealsContent,
  featuredDeals => featuredDeals.isLoaded,
);

export const selectFeaturedDealsPlacements = createSelector(
  selectFeaturedDealsContent,
  featuredDeals => featuredDeals.offers,
);

export const selectFeaturedDealsPlacementsToDisplay = createSelector(
  [selectFeaturedDealsPlacements, selectIsMobileMQ],
  (featuredDealsPlacements, isMobileMQ) => {
    const numberToShow = isMobileMQ ? 5 : 12;
    return shuffle(featuredDealsPlacements).slice(0, numberToShow);
  },
);

// heading selectors
export const selectFeaturedDealsHeading = createSelector(
  selectFeaturedDeals,
  ({ featuredDealsHeading }) => featuredDealsHeading,
);

export const selectFeaturedDealsHeadingIsLoading = createSelector(
  selectFeaturedDealsHeading,
  ({ isLoading }) => isLoading,
);

export const selectFeaturedDealsHeadingIsLoaded = createSelector(
  selectFeaturedDealsHeading,
  ({ isLoaded }) => isLoaded,
);

export const selectFeaturedDealsHeadingData = createSelector(
  selectFeaturedDealsHeading,
  ({ data }) => data,
);
